import { IonContent, useIonViewWillLeave, IonButtons, IonButton, IonSearchbar, IonModal, IonFab, IonFabButton, IonFabList, IonLabel, IonInput, IonItemOption, IonItemOptions, IonItemSliding, IonBackButton, IonList, IonItem, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, useIonAlert, IonImg, IonSpinner, IonThumbnail, IonText, IonListHeader } from '@ionic/react';
import { add, searchOutline, barcodeOutline, downloadOutline, closeOutline, calendarOutline, chevronForward } from 'ionicons/icons';
import './order.css';
import { people } from 'ionicons/icons'
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import { useParams } from 'react-router';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useIonViewDidEnter, useIonViewWillEnter, useIonRouter } from '@ionic/react';
import { useLocalStorage } from '../components/useLocalStorage';
import { useScannerBridge } from '../hooks/useScannerBridge';
import { DataGrid, GridActionsCellItem, GridCellModes, GridCellModesModel, GridCellParams, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import {Html5Qrcode} from "html5-qrcode";

interface Picture {
  path: string;
}

interface ArtInfo {
  id: string;
  name: string;
  accounting_connector: string;
  quantity: string;
  pictures: Picture[];
}

interface ArtReturn {
  Description: string;
  ArticleNumber: string;
  quantity: string;
}

const Order: React.FC = () => {

  const { id } = useParams<{ id: string }>();
  const modal = useRef<HTMLIonModalElement>(null);
  const [showModal, setShowModal] = useState(false);
  let [artinfo, setartinfo] = useState<ArtInfo | null>(null);
  let [artreturn, setartreturn] = useState<ArtReturn | null>(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  let [OrderResult, setOrderResult] = useLocalStorage("order", "");
  let [products, setProducts] = useState([]);
  const [presentAlert] = useIonAlert();
  const router = useIonRouter();
  let [qty, setqty] = useState("");
  let [returnqty, setreturnqty] = useState("0");
  const [scannerActive, setScannerActive] = useState(false);
  const [scannerLoading, setScannerLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const scanTaskRef = useRef<string>("");

  const api = getApi();

  function updateArticle(name: any, accounting_connector: any, quantity: any) {
    addArticle(name, accounting_connector, quantity)
    setqty("")
    setartinfo(null)
    setShowInfoModal(false);
  }

  function articleinfo(art: any, qty: any) {
    setShowInfoModal(true);
    setqty(qty)
    api.get("/api/bbe/articles/?accounting_connector="+art)
        .then(res => {
          console.log(res.data)
          if(res.data.count == 1){
            setartinfo(res.data.results[0])
          } else {
            presentAlert({
              message: 'Fel vid inläsningen av artikeln!',
              buttons: ['OK'],
            })
          }
        })
  }

  useIonViewWillEnter(() => {
    setOrderResult({});
    setProducts([]);
  });

  useIonViewDidEnter(() => {
    api.get("/fortnox/orders/"+id+"/")
      .then(res => {
        console.log(res.data)
        setOrderResult(res.data.Order)
      })

      api.get("/api/bbe/articles/")
      .then(res => {
        console.log(res.data)
        setProducts(res.data.results)
      })

  });

  const handleChange = (ev: Event) => {
    let query = "";
    const target = ev.target as HTMLIonSearchbarElement;
    if (target) query = target.value!.toLowerCase();

      api.get("/api/bbe/articles/?search="+query)
        .then(res => {
          console.log(res.data.Customers)
          setProducts(res.data.results)
        })

    console.log(query);
  }

  function addArticle(name: any, accounting_connector: any, quantity?: number) {
    console.log(name)
    console.log(accounting_connector)
    console.log(OrderResult)
    console.log(OrderResult.OrderRows)

    let existingArticle = OrderResult.OrderRows.find((row: any) => row.ArticleNumber === accounting_connector);

    if (existingArticle) {
      // If quantity is 0 remove the article
      if (Number(quantity) === 0) {
        Delete(accounting_connector);
        return;
      }
      if (quantity) {
        existingArticle.OrderedQuantity = quantity;
      } else {
        existingArticle.OrderedQuantity += 1;
      }
    } else {
        let art = {
            Description: name,
            ArticleNumber: accounting_connector,
            OrderedQuantity: 1.00,
        }
        let newOrderResult = { ...OrderResult };
        newOrderResult.OrderRows = [...newOrderResult.OrderRows, art];
        delete newOrderResult.OrderType;
        delete newOrderResult.TaxReduction;
        setOrderResult(newOrderResult);
    }

    setShowModal(false);
}

  function Update(updatedRow: any): { RowId: any; } {
    console.log(updatedRow)
    OrderResult.OrderRows.map((row: any) => {
        if(row.RowId === updatedRow.RowId){
            row.OrderedQuantity = updatedRow.OrderedQuantity
        }
    })

    setOrderResult(OrderResult)

    return updatedRow;
  }

  function save(){
    setIsSaving(true);
    // Destructure CustomerNumber and OrderRows from OrderResult
    const { CustomerNumber, OrderRows } = OrderResult;

    // Create a new OrderResult object with cleaned OrderRows
    // Create a new OrderResult object with only CustomerNumber and cleaned OrderRows
    const cleanedOrderResult = {
      CustomerNumber,
      OrderRows: OrderRows
    };

    let data = [{"Order": cleanedOrderResult}]
    console.log(data)

    api.post('/fortnox/orders/update/', {
      id: OrderResult.DocumentNumber,
      data: JSON.stringify(data)
    })
    .then(function (response) {
      console.log(response);
      setIsSaving(false);
      router.goBack();
    })
    .catch(function (error) {
      setIsSaving(false);
      console.log(error.response.data.ErrorInformation.message);

      presentAlert({
        message: error.response.data.ErrorInformation.message,
        buttons: ['OK'],
      })
    });
  }



  const handleScan = useCallback((code: string) => {
    if (!code || scannerLoading) return;
    
    // Close modal but keep camera running for next scan
    setScannerActive(false);
    setScannerLoading(false);
    
    const trimmed = code.trim();
    const task = scanTaskRef.current;
    console.log('Scanned code:', trimmed, 'Task:', task);
    
    if (task === "add") {
      api.get("/api/bbe/articles/?accounting_connector=" + trimmed)
        .then(res => {
          console.log(res.data);
          if (res.data.count == 1) {
            addArticle(res.data.results[0].name, res.data.results[0].accounting_connector);
          } else {
            presentAlert({
              message: 'Det finns ingen artikel med det artikelnumret!',
              buttons: ['OK'],
            });
          }
        })
        .catch(err => {
          console.error('Failed to fetch article:', err);
          presentAlert({
            message: 'Kunde inte hämta artikelinformation',
            buttons: ['OK'],
          });
        });
    }
    
    if (task === "return") {
      let existingArticle = OrderResult.OrderRows.find((row: any) => row.ArticleNumber === trimmed);
      if (existingArticle) {
        setreturnqty(existingArticle.OrderedQuantity);
        setartreturn(existingArticle);
        setShowReturnModal(true);
      } else {
        presentAlert({
          message: 'Det finns ingen artikel med det artikelnumret!',
          buttons: ['OK'],
        });
      }
    }
  }, [scannerLoading, api, presentAlert, OrderResult]);

  const { startScanner, stopScanner } = useScannerBridge({ autoStart: false, onScan: handleScan });

  const startScan = async (task: string) => {
    scanTaskRef.current = task;
    if (scannerLoading || scannerActive) return;
    
    // Show modal immediately for instant feedback
    setScannerActive(true);
    setScannerLoading(true);
    
    // Start scanner in background
    try {
      await startScanner();
      setScannerLoading(false);
    } catch (error) {
      console.error('Failed to start scanner:', error);
      setScannerActive(false);
      setScannerLoading(false);
      presentAlert({
        header: 'Fel',
        message: 'Kunde inte starta skannern. Kontrollera behörigheter.',
        buttons: ['OK']
      });
    }
  };

  const handleStopScanner = () => {
    stopScanner();
    setScannerActive(false);
    setScannerLoading(false);
    scanTaskRef.current = "";
  };

  useIonViewWillLeave(() => {
    if (scannerActive) {
      stopScanner();
      setScannerActive(false);
    }
  });


  function Delete(id: any) {
    console.log("Delete")

    setOrderResult((prev:any) => {
      const items = OrderResult.OrderRows.filter((art: any) => art.ArticleNumber !== id)
      const newState = prev;
      OrderResult.OrderRows = items;
      setShowInfoModal(false);
      return { ...newState };
    });
  }

  function showpdf(id: any) {
    api.get(`/fortnox/v2/order/${id}/?pdf=true`, 
        {responseType: 'blob'} 
      ).then((response) => {
        //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data], 
              {type: 'application/pdf'});
        //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
            window.open(fileURL);
        })
        .catch(error => {
            console.log(error);
        });
    }

    function deliver(id: any) {
      api.get(`/fortnox/v2/order/${id}/?send=true`, 
          {responseType: 'blob'} 
        ).then((response) => {
          router.goBack();
          })
          .catch(error => {
              console.log(error);
          });
      }

    const [barcodeRead, setBarcodeRead] = useState("");

    if (barcodeRead.length > 0) {

      api.get("/api/bbe/articles/?accounting_connector="+barcodeRead)
      .then(res => {
        console.log(res.data)
        if(res.data.count == 1){
          addArticle(res.data.results[0].name, res.data.results[0].accounting_connector)
        } else {
          presentAlert({
            message: 'Det finns ingen artikel med artikelnumret: '+barcodeRead,
            buttons: ['OK'],
          })
        }
      })

      setBarcodeRead(""); 

    }
  
    const barcode = {
      timing: 1000,
      data: "",
    };
  
    const barcodeReaded = () => {
      if (barcode.data.length > 5) {
        setBarcodeRead(barcode.data);

      } else {
        barcode.data = "";
      }
    };
  
    let timeout = setTimeout(barcodeReaded, 500);
  
    useEffect(() => {
      window.addEventListener("keypress", (e) => {
        console.log(e.key);
        console.log(e.timeStamp);
        if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 200) {
          if (e.key === "Enter") {
            barcodeReaded();
            barcode.data = ""; // Reset barcode data
            barcode.timing = 1000; // Reset barcode timing
            return
          } else {
          barcode.data += e.key;
          barcode.timing = e.timeStamp;
          clearTimeout(timeout);
          timeout = setTimeout(barcodeReaded, 500);
          }
        } else {
          barcode.data = "";
        }
        console.log(barcode);
      });
    }, []);


    function returnArticle(ArticleNumber: any) {
      let existingArticle = OrderResult.OrderRows.find((row: any) => row.ArticleNumber === ArticleNumber);
      if (existingArticle) {
        if (returnqty > existingArticle.OrderedQuantity) {
          presentAlert({
            message: 'Det finns bara '+existingArticle.OrderedQuantity+'st av denna artikel med i ordern!',
            buttons: ['OK'],
          })
        }
        if (returnqty == existingArticle.OrderedQuantity) {
          Delete(ArticleNumber)
          setShowReturnModal(false);
        }
        if (returnqty < existingArticle.OrderedQuantity) {
          existingArticle.OrderedQuantity = existingArticle.OrderedQuantity - Number(returnqty);
          setShowReturnModal(false);
        }
      }
    }

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {scannerActive ? (
              <IonButton onClick={handleStopScanner} color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon slot="icon-only" icon={closeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              </IonButton>
            ) : (
              <IonBackButton />
            )}
          </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {scannerActive ? 'Skanna streckkod' : `Order: ${OrderResult?.DocumentNumber || id}`}
          </IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
        
      </IonHeader>
      <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <div 
          id="data-capture-view" 
          style={{ position: 'fixed', inset: 0, zIndex: 20, pointerEvents: 'none', display: scannerActive ? 'block' : 'none' }} 
        />
        
        {(!OrderResult || !OrderResult.DocumentNumber) && !scannerActive ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'var(--ion-color-medium)'
          }}>
            <IonSpinner name="crescent" style={{ width: '48px', height: '48px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div style={{ marginTop: '16px' }}>Hämtar orderinformation...</div>
          </div>
        ) : (
          <>
        <div className="top">
          <IonCard className="card" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonList lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon icon={calendarOutline} slot="start" color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                  <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>Orderdatum</p>
                    <h3 style={{ margin: 0, fontWeight: '600' }}>{ OrderResult.OrderDate }</h3>
                  </IonLabel>
                </IonItem>
                {OrderResult.DeliveryDate && (
                  <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonIcon icon={calendarOutline} slot="start" color="secondary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                    <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>Leveransdag</p>
                      <h3 style={{ margin: 0, fontWeight: '600' }}>{ OrderResult.DeliveryDate }</h3>
                    </IonLabel>
                  </IonItem>
                )}
              </IonList>

              <IonRow style={{ marginTop: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonButton fill="outline" onClick={() => showpdf(OrderResult.DocumentNumber)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    Visa PDF
                  </IonButton>
                </IonCol>
                {OrderResult.Sent === false && (
                  <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonButton color="warning" fill="outline" onClick={() => deliver(OrderResult.DocumentNumber)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      Skicka
                    </IonButton>
                  </IonCol>
                )}
              </IonRow>
              <IonButton style={{ marginTop: '8px' }} color="success" onClick={() => save()} disabled={isSaving} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                {isSaving ? <IonSpinner name="crescent" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /> : 'Spara och gå tillbaka'}
              </IonButton>
            </IonCardContent>
          </IonCard>
        </div>

        <IonCard className="card" style={{ marginTop: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonListHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel style={{ fontWeight: 'bold' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Artiklar ({OrderResult.OrderRows?.length || 0})</IonLabel>
            </IonListHeader>
            
            { OrderResult.OrderRows?.map((art: any) => (
              <IonItemSliding key={art.ArticleNumber} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonItem 
                  button 
                  detail={true}
                  onClick={() => {
                    console.log('Opening article info for:', art['ArticleNumber']);
                    articleinfo(art['ArticleNumber'], art['OrderedQuantity']);
                  }}
                  placeholder={undefined} 
                  onPointerEnterCapture={undefined} 
                  onPointerLeaveCapture={undefined}
                >
                  <div slot="start" style={{ 
                    backgroundColor: 'var(--ion-color-light)', 
                    borderRadius: '8px', 
                    padding: '8px', 
                    minWidth: '44px', 
                    textAlign: 'center' 
                  }}>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{ art['OrderedQuantity'] }</div>
                    <div style={{ fontSize: '10px', textTransform: 'uppercase', color: 'var(--ion-color-medium)' }}>st</div>
                  </div>
                  <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <h2 style={{ fontWeight: '600', fontSize: '15px' }}>{ art['Description'] }</h2>
                    <p style={{ fontSize: '12px' }}>Art.nr: { art['ArticleNumber'] }</p>
                  </IonLabel>

                </IonItem>
                <IonItemOptions side="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonItemOption color="danger" onClick={() => Delete(art['ArticleNumber'])} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    Ta bort
                  </IonItemOption>
                </IonItemOptions>
              </IonItemSliding>
            ))}

            {(!OrderResult.OrderRows || OrderResult.OrderRows.length === 0) && (
              <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonLabel style={{ textAlign: 'center', color: '#999', padding: '40px 20px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  Inga artiklar tillagda än
                </IonLabel>
              </IonItem>
            )}
          </IonList>
        </IonCard>


        <IonFab slot="fixed" vertical="bottom" horizontal="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonFabButton onClick={() => setShowModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={add} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
          </IonFabButton>
          <IonFabList side="top" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonFabButton onClick={() => setShowModal(true)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={searchOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
            <IonFabButton onClick={() => startScan("add")} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={barcodeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
            <IonFabButton onClick={() => startScan("return")} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={downloadOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
          </IonFabList>
        </IonFab>

          </>
        )}
      </IonContent>

        <IonModal 
          isOpen={showModal} 
          onDidDismiss={() => setShowModal(false)}
          placeholder={undefined} 
          onPointerEnterCapture={undefined} 
          onPointerLeaveCapture={undefined}
        >
          <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Sök artikel</IonTitle>
              <IonButtons slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonButton onClick={() => setShowModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon icon={closeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonSearchbar 
              placeholder="Sök på namn eller artikelnummer" 
              debounce={500} 
              onIonChange={(ev) => handleChange(ev)} 
              onPointerEnterCapture={undefined} 
              onPointerLeaveCapture={undefined}
            />
            <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              { products.map((result: any) => (
                <IonItem 
                  key={result.accounting_connector}
                  button
                  onClick={() => addArticle(result["name"], result["accounting_connector"])} 
                  placeholder={undefined} 
                  onPointerEnterCapture={undefined} 
                  onPointerLeaveCapture={undefined}
                >
                  {result.pictures && result.pictures.length > 0 ? (
                    <IonThumbnail slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonImg src={result.pictures[0].path} alt={result.name} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                    </IonThumbnail>
                  ) : (
                    <IonThumbnail slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonImg src="https://butik.bbe.nu/assets/images/no-product-image.jpg" alt="No image" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                    </IonThumbnail>
                  )}
                  <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <h2 style={{ fontWeight: 'bold', fontSize: '16px' }}>{ result["name"] }</h2>
                    <p style={{ fontSize: '13px' }}>Art.nr: { result["accounting_connector"] }</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '6px' }}>
                      <IonText color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <span style={{ fontSize: '15px', fontWeight: '700' }}>{ result["sale_price"] || result["price"] } kr</span>
                      </IonText>
                      {result["quantity"] !== undefined && (
                        <IonText color={Number(result["quantity"]) > 0 ? "success" : "danger"} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <span style={{ fontSize: '12px', fontWeight: '500' }}>
                            Lager: { Math.round(Number(result["quantity"])) } st
                          </span>
                        </IonText>
                      )}
                    </div>
                  </IonLabel>
                </IonItem>
              ))}
            </IonList>
          </IonContent>
        </IonModal>

        <IonModal 
          isOpen={showInfoModal} 
          onDidDismiss={() => setShowInfoModal(false)}
          placeholder={undefined} 
          onPointerEnterCapture={undefined} 
          onPointerLeaveCapture={undefined}
        >
          <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Artikeldetaljer</IonTitle>
              <IonButtons slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonButton onClick={() => setShowInfoModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon icon={closeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  
                  <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCol size="12" size-sm="6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Artikelnummer:</IonCol>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artinfo?.accounting_connector} </IonCol>
                          </IonRow>
                        </IonItem>
                        
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol size="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Namn:</IonCol>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artinfo?.name} </IonCol>
                          </IonRow>
                        </IonItem>
        
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>I lager:</IonCol>
                            <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <span>{Number(artinfo?.quantity)} </span></IonCol>
                          </IonRow>
                        </IonItem>
        
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size="5" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Beställ antal:</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <IonInput type="number" onIonChange={(e) => setqty(e.detail.value!)} value={qty} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}></IonInput></IonCol>
                        </IonItem>
                        <IonImg
                            src={artinfo?.pictures[0]?.path || "https://butik.bbe.nu/assets/images/no-product-image.jpg"}
                            alt="Ingen bild :)" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonImg>
                      </IonList>
                      </IonCol>
                    </IonRow>
                    <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton size="large" color="danger" onClick={() => Delete(artinfo?.accounting_connector)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ta bort artikel</IonButton></IonCol>
                    </IonRow>
                    <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton size="large" color="success" onClick={() => updateArticle(artinfo?.name, artinfo?.accounting_connector, qty)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton></IonCol>
                    </IonRow>
                  </IonGrid>
                    
                  </IonContent>
                </IonModal>

        <IonModal 
          isOpen={showReturnModal} 
          onDidDismiss={() => setShowReturnModal(false)}
          placeholder={undefined} 
          onPointerEnterCapture={undefined} 
          onPointerLeaveCapture={undefined}
        >
          <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonToolbar color="warning" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Returnera artikel</IonTitle>
              <IonButtons slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonButton onClick={() => setShowReturnModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon icon={closeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  
                  <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCol size="12" size-sm="6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow className='fullwidth' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Artikelnummer:</IonCol>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artreturn?.ArticleNumber} </IonCol>
                          </IonRow>
                        </IonItem>
                        
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow className='fullwidth' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol size="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Namn:</IonCol>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artreturn?.Description} </IonCol>
                          </IonRow>
                        </IonItem>
        
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size="8" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Antal att lämna tillbaka:</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <IonInput className='fullwidth' type="number" onIonChange={(e) => setreturnqty(e.detail.value!)} value={returnqty} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}></IonInput></IonCol>
                        </IonItem>
                        
                      </IonList>
                      </IonCol>
                    </IonRow>
                    <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton size="large" color="primary" onClick={() => returnArticle(artreturn?.ArticleNumber)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Lämna tillbaka</IonButton></IonCol>
                      <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton size="large" color="warning" onClick={() => setShowReturnModal(false)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Avbryt</IonButton></IonCol>
                    </IonRow>
                  </IonGrid>
                    
                  </IonContent>
                </IonModal>


    </IonPage>
  );
};

export default Order;
